import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/paymentTypes/1.svg'
import _imports_1 from '@/assets/paymentTypes/2.svg'
import _imports_2 from '@/assets/paymentTypes/3.svg'
import _imports_3 from '@/assets/paymentTypes/4.svg'
import _imports_4 from '@/assets/paymentTypes/5.svg'
import _imports_5 from '@/assets/paymentTypes/6.svg'
import _imports_6 from '@/assets/paymentTypes/7.svg'
import _imports_7 from '@/assets/paymentTypes/8.svg'


const _withScopeId = n => (_pushScopeId("data-v-4e603c88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-types-list" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "payment-types-list__item"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "payment-types-list__item"
  })
], -1))
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "footer-menu__item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoFooter = _resolveComponent("MoFooter")!

  return (_openBlock(), _createBlock(_component_MoFooter, {
    "copyright-start-year": _ctx.copyrightStartYear,
    "style-object": _ctx.styleObject
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedDocuments, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item.id,
          href: item.url,
          target: "_blank",
          rel: "noreferrer noopener",
          class: "footer-menu__item footer-menu__item--filled"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1)
        ], 8, _hoisted_2))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countOfEmptyFields, (emptyBlock) => {
        return (_openBlock(), _createElementBlock("div", {
          key: emptyBlock,
          class: "footer-menu__item"
        }))
      }), 128))
    ]),
    _: 2
  }, [
    (_ctx.companyStore.activeCompany?.login === _ctx.DS1_LOGIN)
      ? {
          name: "paymentTypes",
          fn: _withCtx(() => [
            _hoisted_1
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["copyright-start-year", "style-object"]))
}